export default __webpack_public_path__ + "static/bg-2-99aa36b4ce98735404b2c91bebc1a050.jpg";